var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.heading
      ? _c("h2", { staticClass: "c-toc__heading" }, [
          _vm._v(_vm._s(_vm.heading))
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      {
        directives: [
          { name: "scroll-spy-active", rawName: "v-scroll-spy-active" },
          { name: "scroll-spy-link", rawName: "v-scroll-spy-link" }
        ],
        staticClass: "c-toc__list"
      },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }